<template>
  <div class="wishlist-icon">
    <span v-if="userIsLoggedIn">
      <span
        v-if="updateWishlist"
        @click="removeWishlist"
        class="selected-wishlist"
      ></span>
      <span v-else @click="addWishlist" class="unselected-wishlist"></span>
    </span>

    <a v-else :href="redirectUrl" class="unselected-wishlist"><span class="is-sr-only">wishlist</span></a>
  </div>
</template>

<script>
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'vch-wishlist-icon',
  props: {
    dataId: {
      type: String,
      required: true,
    },
    addWishlistApi: {
      type: String,
      required: false,
    },
    removeWishlistApi: {
      type: String,
      required: false,
    },
    isWishlisted: {
      type: Boolean,
      required: false,
    },
    redirectUrl: {
      type: String,
      required: false,
    },
    isWishlistApi: {
      type: String,
      required: false,
    },
    wishlistDataAnalytics: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      updateWishlist: false,
      userIsLoggedIn: false,
      wishlistDataLayer: null,
    };
  },
  mounted() {
    this.wishlistOnload();
    this.wishlistDataLayer = JSON.parse(this.wishlistDataAnalytics);
  },
  methods: {
    async addWishlist() {
      try {
        const response = await fetch(
          `${this.addWishlistApi}?id=${this.dataId}`,
          {
            method: 'POST',
          }
        );

        if (response.ok) {
          this.updateWishlist = true;
          this.pushSubmitTags();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async removeWishlist() {
      try {
        const response = await fetch(
          `${this.removeWishlistApi}?id=${this.dataId}`,
          {
            method: 'POST',
          }
        );

        if (response.ok) {
          this.updateWishlist = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async wishlistOnload() {
      try {
        const response = await fetch(
          `${this.isWishlistApi}?id=${this.dataId}`,
          {
            method: 'POST',
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.userIsLoggedIn = data.isUserLogin;
          this.updateWishlist = data.isWishlisted;
        } else {
          console.error('Failed to fetch wishlist status.');
        }
      } catch (error) {
        console.error(error);
      }
    },
    pushSubmitTags() {
      pushEvent({
        event: this.wishlistDataLayer?.data?.event,
        event_name: this.wishlistDataLayer?.data?.event_name,
        eventCategory: this.wishlistDataLayer?.data?.eventCategory,
        eventAction: this.wishlistDataLayer?.data?.eventAction,
        eventLabel: this.wishlistDataLayer?.data?.eventLabel,
        product_info: this.wishlistDataLayer?.data?.product_info,
        ecommerce: {
          products: [
            {
              name: this.wishlistDataLayer?.data?.ecommerce?.products?.name,
              id: this.wishlistDataLayer?.data?.ecommerce?.products?.id,
              price: this.wishlistDataLayer?.data?.ecommerce?.products?.price,
              brand: this.wishlistDataLayer?.data?.ecommerce?.products?.brand,
              category:
                this.wishlistDataLayer?.data?.ecommerce?.products?.category,
              variant:
                this.wishlistDataLayer?.data?.ecommerce?.products?.variant,
              dimension35:
                this.wishlistDataLayer?.data?.ecommerce?.products?.dimension35,
              dimension36:
                this.wishlistDataLayer?.data?.ecommerce?.products?.dimension36,
              dimension38:
                this.wishlistDataLayer?.data?.ecommerce?.products?.dimension38,
              dimension48:
                this.wishlistDataLayer?.data?.ecommerce?.products?.dimension48,
              dimension59:
                this.wishlistDataLayer?.data?.ecommerce?.products?.dimension59,
              dimension91:
                this.wishlistDataLayer?.data?.ecommerce?.products?.dimension91,
            },
          ],
        },
      });
    },
  },
};
</script>
<style lang="scss" src="./wishlist-icon.scss"></style>
